import { VARIANTS } from 'components/alerts'
import { FLASH_MESSAGE, GENERIC_FAILURE_MESSAGE } from 'shared/constants'

export const successMessage = (msg) =>
  PubSub.publish(FLASH_MESSAGE, { message: msg, variant: VARIANTS.SUCCESS })
export const infoMessage = (msg) =>
  PubSub.publish(FLASH_MESSAGE, { message: msg, variant: VARIANTS.INFO })
export const errorMessage = (msg = GENERIC_FAILURE_MESSAGE) =>
  PubSub.publish(FLASH_MESSAGE, { message: msg, variant: VARIANTS.DANGER })
